import { HttpClient } from "@angular/common/http";
import { Inject, Injectable, inject } from "@angular/core";
import { EnvConfig, Environment } from "@doc/core";
import { Observable, of } from "rxjs";
import { Lookups } from "../data";
import { ApiUrls } from "../backoffice-urls";
import {
  BaseResponse,
  EnumDeleteRequest,
  EnumGetListRequest,
  EnumGetListResponse,
  EnumItemGetListResponse,
  EnumInsertRequest,
} from "../models";

@Injectable({
  providedIn: "root",
})
export class LookupService {
  private http = inject(HttpClient);
  private apiUrl: string;
  private baseUrl: string;

  constructor(@Inject(EnvConfig) private config: Environment) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  getAllLookups() {
    const activeLookups = Lookups.filter((x) => x.isActive);
    return of(activeLookups);
  }

  getAllEnums(body: EnumGetListRequest) {
    const link = this.apiUrl + ApiUrls.getEnums;
    return this.http.post<EnumGetListResponse>(link, body);
  }

  getEnumItems(enumTypeName: string) {
    const link = this.apiUrl + ApiUrls.getEnumItems + "/" + enumTypeName;
    return this.http.get<EnumItemGetListResponse>(link);
  }

  deleteEnum(body: EnumDeleteRequest) {
    const link = this.apiUrl + ApiUrls.deleteEnum;
    return this.http.post<BaseResponse>(link, body);
  }

  insertEnum(body: EnumInsertRequest) {
    const link = this.apiUrl + ApiUrls.insertEnum;
    return this.http.post<BaseResponse>(link, body);
  }

  updateEnum(body: any) {
    const link = this.apiUrl + ApiUrls.updateEnum;
    return this.http.post<BaseResponse>(link, body);
  }

  getEnumById(id: any) {
    const link = this.apiUrl + ApiUrls.getEnumById + "/" + id;
    return this.http.get<any>(link);
  }

  createLookupItem(body: any) {
    const link = this.apiUrl + ApiUrls.createLookUp;
    return this.http.post<any>(link, body);
  }

  getlookupItemById(body: any) {
    const link = this.apiUrl + ApiUrls.getLookupById;
    return this.http.post<any>(link, body);
  }

  updateLookItem(body: any) {
    const link = this.apiUrl + ApiUrls.updateLookUp;
    return this.http.post<any>(link, body);
  }

  getLookupItems(id: number) {
    const link = `${this.apiUrl}${ApiUrls.getLookupItems}?type=${id}`;
    return this.http.get<any>(link);
  }

  getOrganizationalHierarchy(id: number) {
    const link = `${this.apiUrl}${ApiUrls.organizationalHierarchy}?id=${id}`;
    return this.http.get<any>(link);
  }

  getLookUpByParentId(body: any) {
    const link = this.apiUrl + ApiUrls.getLookUpByParentId;
    return this.http.post<any>(link, body);
  }

  getTaskStatusLookup() {
    const link = `${this.apiUrl}${ApiUrls.gettaskStatusLookup}`;
    return this.http.get<any>(link);
  }

  getParticipationType(): Observable<any> {
    const link = `${this.apiUrl}${ApiUrls.GetParticipationTypesLookUp}`;
    return this.http.get<any>(link);
  }

  deleteLookups(body: any) {
    const link = this.apiUrl + ApiUrls.deleteLookupItems;
    return this.http.post<any>(link, body);
  }

  saveSubjectWithLevels(body: any) {
    const link = this.apiUrl + ApiUrls.updateSubjectWithLevels;
    return this.http.post<any>(link, body);
  }

  getAllSchedulerConfiguration(body: any) {
    const link = this.apiUrl + ApiUrls.GetAllConfiguration;
    return this.http.post<any>(link, body);
  }

  getSchedulerConfigurationByCode(code: any) {
    const link = `${this.apiUrl}${ApiUrls.GetConfigurationByCode}/${code}`;
    return this.http.get<any>(link);
  }

  updateSchedulerConfiguration(body: any) {
    const link = this.apiUrl + ApiUrls.UpdateConfiguration;
    return this.http.put<any>(link, body);
  }

  createSchedulerConfiguration(body: any) {
    const link = this.apiUrl + ApiUrls.CreateConfiguration;
    return this.http.put<any>(link, body);
  }

  getConfidentialityLookupItems(payload: any) {
    const link = this.apiUrl + ApiUrls.getConfidentialityLookupItems;
    return this.http.post<any>(link, payload);
  }

  fetchAllLookups(body: any) {
    const link = this.apiUrl + ApiUrls.getAllLookUps;
    return this.http.post<any>(link, body);

  }

  createLookUp(body: any) {
    const link = this.apiUrl + ApiUrls.createNewLookup;
    return this.http.post<any>(link, body);
  }

  getLookUpById(id: any) {
    const link = `${this.apiUrl}${ApiUrls.getLookUpByID}/${id}`;
    return this.http.get<any>(link);
  }

  updateLookUp(body: any, id: any) {
    const link = this.apiUrl + ApiUrls.updateLookUpName + `/${id}`;
    return this.http.post<any>(link, body);
  }


  deleteLookup(id: any) {
    const link = `${this.apiUrl}${ApiUrls.deleteLookUp}/${id}`;
    return this.http.get<any>(link);
  }

  getLookupDetailsListById(id: any, body: any) {
    const link = `${this.apiUrl}${ApiUrls.lookupDetailsById}/${id}`;
    return this.http.post<any>(link, body);
  }

  createLookupDetails(body: any) {
    const link = this.apiUrl + ApiUrls.ceateLookupDetails;
    return this.http.post<any>(link, body);
  }

  updateLookupDetails(body: any, id: any) {
    const link = this.apiUrl + ApiUrls.updateLookUpDetails + `/${id}`;
    return this.http.post<any>(link, body);
  }

  UpdateLookUpDetailsDefaultValue(lookupId:any, code:any){
    const link = `${this.apiUrl}${ApiUrls.UpdateLookUpDetailsDefaultValue}${lookupId}/${code}`;
    return this.http.post<any>(link, {});
  }

  getLookupDetailsById(id: any) {
    const link = this.apiUrl + ApiUrls.getLookupdetailsById + `/${id}`;
    return this.http.get<any>(link);
  }

  deleteLookupDetails(id: any) {
    const link = `${this.apiUrl}${ApiUrls.deleteLookUpDetails}/${id}`;
    return this.http.get<any>(link);
  }




}
